import {effect, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import { UserService } from './core/user.service';
import { Global } from './core/Global';

@Injectable()

export class ReportService {
	private url: string;
	private entity: any


	constructor(
		private _http: HttpClient,
		private _userService: UserService,
	) {
		this.url = Global.url_seguros;
		this.entity = this._userService.sharingEntity()
		
	}
	get(policy: number, period: string): Observable<any> {
		//entidad.campo = this.identity.campo;
		let params = {};
		//definir las cabeceras
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		
		//Hacer peticion ajax
		return this._http.get(this.url + "get-payrolls", {headers: headers, params: {policy, period}})

	}

	generateExcel(payroll: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		//Hacer peticion ajax
		return this._http.post(this.url + "reports/payroll-excel", payroll, {headers: headers, responseType: 'blob'})

	}

}
